<script>
export default {
  props: {
    modelValue: {
      type: Object,
      default: () => null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      allCustomAttributes: [],
      customAttribute: null,
      attributeValue: '',
    };
  },
  computed: {
    conversationCustomAttributes() {
      return this.allCustomAttributes.filter(
        attribute => attribute.attribute_model === 'conversation_attribute'
      );
    },
    contactCustomAttributes() {
      return this.allCustomAttributes.filter(
        attribute => attribute.attribute_model === 'contact_attribute'
      );
    },
  },
  mounted() {
    this.allCustomAttributes = this.$store.getters['attributes/getAttributes'];
    this.customAttribute = this.modelValue[0]?.custom_attribute;
    this.attributeValue = this.modelValue[0]?.attribute_value;

    this.updateValue();
  },
  methods: {
    updateValue() {
      this.$emit('update:modelValue', {
        custom_attribute: this.customAttribute,
        attribute_value: this.attributeValue,
      });
    },
  },
};
</script>

<template>
  <div>
    <select
      v-model="customAttribute"
      class="max-w-full mb-0 mt-1 mr-1"
      :allow-empty="false"
      @change="updateValue"
    >
      <option disabled>Atributos personalizados da conversa</option>
      <option
        v-for="attribute in conversationCustomAttributes"
        :key="attribute.id"
        :value="attribute"
      >
        {{ attribute.attribute_display_name }}
      </option>
      <option disabled>Atributos personalizados do contato</option>
      <option
        v-for="attribute in contactCustomAttributes"
        :key="attribute.id"
        :value="attribute"
      >
        {{ attribute.attribute_display_name }}
      </option>
    </select>
    <input
      v-model="attributeValue"
      class="mb-0 mt-1"
      type="text"
      placeholder="Valor do atributo"
      @input="updateValue"
    />
  </div>
</template>
